const KEY = "pdm_recently_viewed";
const MAX = 5;

export function getRecentlyViewed() {
  try {
    const list = JSON.parse(localStorage.getItem(KEY) || "[]");
    return Array.isArray(list) ? list.slice(0, MAX) : [];
  } catch {
    return [];
  }
}

export function recordView(product) {
  if (!product || !product.product_id) return;
  try {
    const snap = {
      product_id: product.product_id,
      name: product.name,
      price_cents: product.price_cents,
      image_url: product.image_url,
      weight: product.weight,
      badge: product.badge,
      bookable: product.bookable,
      stock: product.stock,
      featured: product.featured,
    };
    const list = getRecentlyViewed().filter((p) => p.product_id !== product.product_id);
    list.unshift(snap);
    localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX)));
    window.dispatchEvent(new Event("recentlyViewedChange"));
  } catch {
    /* ignore quota / private mode errors */
  }
}
